<template>
  <div class="videoapproval">
    <div class="videoapproval-top">
      <Form ref="selectForm" :model="resource" :label-width="90" class="tabTopForm">
        <FormItem label="申请者类型">
          <Select
            class="select"
            v-model="resource.applyType"
            @on-change="searchSource"
            clearable
            placeholder="全部"
          >
            <Option v-for="item in applyTypeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="认证信息">
          <Input
            v-model.trim="resource.companyName"
            @on-enter="searchSource"
            @on-blur="searchSource"
            clearable
            @on-clear="searchSource"
            placeholder="请输入认证的企业名称"
            style="width: 100%; min-width: 150px"
            class="inputName"
          />
        </FormItem>
        <FormItem label="申请人">
          <Input
            v-model.trim="resource.applyName"
            placeholder="请输入申请人姓名"
            @on-enter="searchSource"
            @on-blur="searchSource"
            clearable
            @on-clear="searchSource"
            style="width: 100%; min-width: 150px"
            class="inputName"
          />
        </FormItem>
        <FormItem label="审核状态">
          <Select
            class="select"
            v-model="resource.checkStatus"
            @on-change="searchSource"
            clearable
            placeholder="全部"
          >
            <Option v-for="item in checkStatusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="提交时间" class="scene">
          <DatePicker
            v-model="resource.createTime"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom"
            placeholder="请选择提交时间"
            :editable="false"
            @on-change="changeTime"
            style="width: 220px"
          ></DatePicker>
        </FormItem>
      </Form>
    </div>
    <div class="content">
      <Row>
        <Table
          class="tableDom"
          ref="tableRef"
          stripe
          :columns="dataCol"
          :loading="tableLoading"
          :data="dataList"
        >
          <!-- 序号 -->
          <template slot-scope="{ index }" slot="xuhao">{{ index + 1 }}</template>
          <template slot-scope="{ row, index }" slot="number">
            <span class="fontblue fontcursor" @click="seeTree(row)">
              {{
              row.number || 0
              }}
            </span>
          </template>
          <!-- 申请者类型 -->
          <template slot-scope="{ row }" slot="applyPersonType">
            <span v-if="row.type == 0">服务使用者</span>
            <span v-if="row.type == 1">服务提供者</span>
          </template>
          <!-- 审核状态0 待审核 1已通过 2已驳回 -->
          <template slot-scope="{ row }" slot="status">
            <span v-if="row.status == 0">
              <div class="circle_dot circle_on"></div>待审核
            </span>
            <span v-if="row.status == 1">
              <div class="circle_dot circle_success"></div>已通过
            </span>
            <span v-if="row.status == 2">
              <div class="circle_dot circle_error"></div>已驳回
            </span>
          </template>
          <template slot-scope="{ row }" slot="action">
            <span>
              <span
                class="fontblue mr-16 fontcursor"
                v-if="row.status == 1 || row.status == 2"
                @click="link('/video/applydetail', row)"
                v-permission="['detail']"
              >查看详情</span>
            </span>
            <span>
              <span
                class="fontblue mr-16 fontcursor"
                v-if="row.status == 0"
                @click="link('/video/applydetail', row)"
                v-permission="['audit']"
              >审核</span>
            </span>
          </template>
        </Table>
      </Row>
      <Row class="mt-16 mr-32" type="flex" justify="end">
        <Page
          :total="totalCount"
          :page-size="search.pageSize"
          :page-size-opts="psize"
          :current="search.pageIndex"
          @on-change="handlePage"
          @on-page-size-change="sizeChange"
          show-sizer
          show-total
          show-elevator
          placement="top"
          class-name="page"
        />
      </Row>
    </div>
    <SelectResource
      v-if="SelectResourceShow"
      @SelectResourceClose="SelectResourceShow = false"
      @SelectResourceResult="SelectResourceResult"
      :id="rowData.id + ''"
      :userType="rowData.type"
      :totalNum="rowData.number"
    ></SelectResource>
  </div>
</template>

<script>
import { getApprovalList } from "@/api/resource";
import SelectResource from "@/components/apply-resource-tree-v2/select-resource.vue";
import TableMixin from "@/utils/mixins/tableMixin";
const dataCol = [
  {
    title: "序号",
    slot: "xuhao",
    tooltip: true,
    minWidth: 80
  },
  {
    title: "申请者类型",
    slot: "applyPersonType",
    tooltip: true,
    minWidth: 140
  },
  {
    title: "认证信息",
    key: "oName",
    tooltip: true,
    minWidth: 120
  },
  {
    title: "申请人",
    key: "applyPersonName",
    minWidth: 100,
    tooltip: true
  },
  {
    title: "电话",
    key: "applyPersonPhone",
    tooltip: true,
    minWidth: 130
  },
  {
    title: "邮箱",
    key: "applyPersonEmail",
    tooltip: true,
    width: 130
  },
  {
    title: "使用场景",
    key: "scenario",
    tooltip: true,
    minWidth: 120
  },
  {
    title: "视频数量",
    slot: "number",
    tooltip: true,
    minWidth: 120
  },
  {
    title: "提交时间",
    key: "createTime",
    tooltip: true,
    minWidth: 120
  },
  {
    title: "审核状态",
    slot: "status",
    tooltip: true,
    minWidth: 120
  },
  {
    title: "操作",
    slot: "action",
    fixed: "right",
    width: 140,
    minWidth: 38
  }
];
export default {
  components: {
    SelectResource
  },
  mixins: [mixins, TableMixin],
  data() {
    return {
      Recovery: {
        path: ["/video/applydetail"],
        key: ["search", "timeList", "resource"]
      },
      stateList: [],
      tableLoading: false,
      totalCount: 0,
      psize: [10, 20, 50, 100],
      search: {
        pageSize: 10,
        pageIndex: 1
      },
      dataList: [],
      dataCol: dataCol,
      showDialog: false,
      type: "add",
      dataForm: {},
      dataId: -1,
      showPwd: false,
      showApply: false, //申请资源
      showDetail: false,
      propsForm: {},
      timeList: [], //时间段
      rowId: null,
      isManager: false,
      userRole: false,
      showTip: false, //操作提示
      type: "",
      resource: {
        applyType: "",
        companyName: "",
        applyName: "",
        checkStatus: "",
        createTime: []
      },
      applyTypeList: [
        {
          id: "0",
          name: "服务使用者"
        },
        {
          id: "1",
          name: "服务提供者"
        }
      ],
      checkStatusList: [
        {
          id: "0",
          name: "待审核"
        },
        {
          id: "1",
          name: "已通过"
        },
        {
          id: "2",
          name: "已驳回"
        }
      ],
      SelectResourceShow: false,
      rowData: {}
    };
  },
  created() {
    this.resource.createTime.length > 0 &&
      (this.resource.createTime = [
        this.$moment(this.resource.createTime[0]).format("YYYY-MM-DD HH:mm"),
        this.$moment(this.resource.createTime[1]).format("YYYY-MM-DD HH:mm")
      ]);
    let status = this.$route.query.status;
    if (status) {
      this.resource.checkStatus = status;
    }
    this.getList();
  },
  mounted() {},
  methods: {
    seeTree(row) {
      console.log(row, "row--");
      this.SelectResourceShow = true;
      this.rowData = row;
    },
    //返回选择的资源和数量
    SelectResourceResult(sources, num) {
      this.SelectResourceShow = false;
    },
    getList() {
      console.log(this.search);
      let query = {
        proposerType: this.resource.applyType,
        companyName: this.resource.companyName,
        proposerName: this.resource.applyName,
        status: this.resource.checkStatus,
        createTimeBegin: this.resource.createTimeBegin,
        createTimeEnd: this.resource.createTimeEnd,
        pageIndex: this.search.pageIndex,
        pageSize: this.search.pageSize
      };
      getApprovalList(query)
        .then(res => {
          this.dataList = res.data.data;
          this.totalCount = res.data.page.totalCount;
          console.log(res.data.data, "资源审核列表");
        })
        .catch(err => {
          console.log(err, "请求接口失败");
        });
    },
    changeTime(time) {
      console.log(time, "time--");
      if (time.length && time[0] != "") {
        this.resource.createTimeBegin = time[0];
        this.resource.createTimeEnd = time[1] + " 23:59:59";
      } else {
        this.resource.createTimeBegin = undefined;
        this.resource.createTimeEnd = undefined;
      }
      this.searchSource();
    },
    link(path, item) {
      if (item) {
        this.$router.push({
          path: path,
          query: {
            id: item.id,
            type: item.type
          }
        });
      } else {
        this.$router.push({ path: path });
      }
    },
    handlePage(value) {
      console.log(
        "handlePagehandlePagehandlePagehandlePagehandlePagehandlePage",
        value
      );
      this.search.pageIndex = value;
      this.getList();
    },
    sizeChange(value) {
      console.log("sizeChangesizeChangesizeChangesizeChangesizeChange", value);
      this.search.pageSize = value;
      this.$nextTick(() => {
        this.getList();
      });
    },
    searchSource() {
      this.search = {
        pageIndex: 1,
        pageSize: this.search.pageSize
      };
      this.getList();
    }
  }
};
</script>

<style lang="scss">
.videoapproval {
  width: 100%;
  height: 100%;
  background: #fff;
  &-top {
    width: 100%;
    padding: 20px;
    margin-bottom: -30px;
    .tabTopForm {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      .ivu-select-single .ivu-select-selection {
        height: 36px;
        padding-top: 2px;
        min-width: 150px;
      }
      // .scene {
      //   margin-right: -80px;
      // }
      // .name {
      //   margin-right: -70px;
      //   .inputName {
      //     min-width: 150px;
      //   }
      // }
    }
    .btn {
      width: 130px;
      height: 36px;
      border-radius: 18px;
      margin-left: 0px;
    }
  }
  .tableDom {
    width: 100%;
    .circle_error {
      background: #f56c6c;
    }
  }
}
</style>
